export default __webpack_public_path__ + "static/media/loader_3d_avax.d64ba400.gif";